import { Logger } from "@lululemon/mwa-logger";
export var getLogger = function (_a) {
    var app = _a.app;
    return new Logger({
        owner: "login",
        app: app
    });
};
